import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 48, height: 48, viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24ZM8.91407 24C8.91407 32.3317 15.6683 39.0859 24 39.0859C32.3317 39.0859 39.0859 32.3317 39.0859 24C39.0859 15.6683 32.3317 8.91407 24 8.91407C15.6683 8.91407 8.91407 15.6683 8.91407 24Z", fill: "#FF0000" }));
const ForwardRef = forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
